import { IAction } from './list.action';
import { StoreObject, StoreObjectType } from './storeObject';

import { NormalizationFieldStatus } from '../models/normalization-field-status.enum';
import { ReactSchema } from '../models/form-generator-schema.model';
import { FormTemplateNormalizationField } from '../models/form-template.model';



export function reducer(currentState, action: IAction) {
	const state = JSON.parse(JSON.stringify(currentState));
	switch (action.type) {
		case 'UpdateSchemaNameAndTitle': {
			state.Schema.title = action.value.Schema.title;
			state.Schema.description = action.value.Schema.description;
			return state;
		}
		case 'UpdateLastNameIndexes': {
			state.Schema.lastFieldNumber = action.value.Schema.lastFieldNumber;
			state.Schema.lastSectionNumber = action.value.Schema.lastSectionNumber;
			return state;
		}
		case 'UpdateDefaultSchema': {
			state.Schema = action.value.Schema;
			state.UiSchema = action.value.UiSchema;
			state.FormData = updateFormDataAfterChange(action.value.Schema, action.value.FormData);
			state.FormTemplateNormalizationFields = action.value.FormTemplateNormalizationFields;
			state.FormDataHasErrors = false;
			currentState = state;
			return state;
		}
		case 'ADD': {
			const propName = action.value.Schema.name;
			const required = action.value.Schema.fieldRequired;
			const formTemplateNormalizationFieldStatusId = action.value.Schema.formTemplateNormalizationFieldStatusId;
			const normalizedField = action.value.Schema.normalizationFieldId;
			const normalizedFieldExceptionCriteriaId = action.value.Schema.normalizationExceptionId;
			const normalizedFieldExceptionCriteriaValue = action.value.Schema.normalizationExceptionValue;
			const exceptionAlias = action.value.Schema.exceptionAlias;
			const exceptionTypeId = action.value.Schema.exceptionTypeId;
			const dataType = action.value.Schema.normalizationFieldDataType;
			const fieldName = action.value.Schema.title;

			const normalizationClassId = action.value.Schema.normalizationClassId;
			const normalizationClassName = action.value.Schema.normalizationClassName;
			const normalizationSubClassId = action.value.Schema.normalizationSubClassId;
			const normalizationSubClassName = action.value.Schema.normalizationSubClassName;
			const normalizationFieldName = action.value.Schema.normalizationFieldName;

			if (action.value.Type !== StoreObjectType.Section) {
				state.FormTemplateNormalizationFields.push({
					fieldId: propName,
					fieldNormalizationId: normalizedField,
					formTemplateNormalizationFieldStatusId: normalizedField == null ? NormalizationFieldStatus.Default : formTemplateNormalizationFieldStatusId,
					normalizationFieldExceptionCriteriaId: normalizedFieldExceptionCriteriaId,
					normalizationFieldExceptionCriteriaValue: normalizedFieldExceptionCriteriaValue,
					exceptionAlias,
					exceptionTypeId,
					dataType,
					fieldName,

					classId: normalizationClassId,
					className: normalizationClassName,
					subClassId: normalizationSubClassId,
					subClassName: normalizationSubClassName,
					normalizationFieldName
				} as FormTemplateNormalizationField);
			}

			delete action.value.Schema.name;
			delete action.value.Schema.fieldRequired;

			if (action.value.Type === StoreObjectType.AnyOf) {
				addAnyOfSection(action.value, propName);
			}
			else if (action.value.Type === StoreObjectType.AnyOfField) {
				addAnyOfElement(action.value, propName, required);
			}
			else if (isNullOrWhiteSpace(action.value.CurrentStoreObj.SectionName)) {
				addElement(action.value, propName, required);
			}
			else {
				addElementToSection(action.value, propName, required);
			}

			return state;
		}

		case 'CLONE': {

			const elementName = action.value.CurrentStoreObj.FieldName;
			const sectionName = action.value.CurrentStoreObj.SectionName;
			const anyOfActionName = action.value.CurrentStoreObj.AnyOfOptionName;

			if (sectionName) {
				if (elementName && anyOfActionName) {
					addCloneElementToAnyOfSection(sectionName, elementName, anyOfActionName);
				}
				else if (!elementName) {
					addCloneSection(sectionName);
				}
				else { addCloneElementToSection(sectionName, elementName); }
			} else { addCloneElement(elementName); }

			return state;
		}

		case 'MOVE': {

			const currentObj = action.value.CurrentStoreObj;

			if (currentObj == null) { return state; }
			if (action.value.Type == null) { return state; }
			const previewObj = action.value.PreviewStoreObj;

			if (action.value.Type === StoreObjectType.AnyOfField) {
				if (action.value.CurrentStoreObj.AnyOfOptionName && action.value.PreviewStoreObj.AnyOfOptionName) {
					moveFieldInsideAnyOfToAnyOfOption(action.value);
				} else if (action.value.CurrentStoreObj.SectionName) {
					moveFieldInsideASectionToAnyOfOption(action.value);
				} else { moveFieldOutsideAnyOfToAnyOfOption(action.value); }
				return state;
			}

			if (action.value.Type === StoreObjectType.Section) {
				if (currentObj.SectionName == null) { return state; }
				if (previewObj != null && previewObj.SectionName != null) // move section after another section
				{
					moveSectionAfterAnotherSection(action.value);
					return state;
				}

				if (previewObj != null && previewObj.SectionName == null && previewObj.FieldName != null) // move section after another element
				{
					moveSectionAfterAnotherElement(action.value);
					return state;
				}

				if (previewObj == null || previewObj.SectionName == null)// move section in the first place
				{
					moveSectionInTheFirstPlace(action.value);
					return state;
				}
			}

			if (action.value.Type === StoreObjectType.Field) {
				if (currentObj.FieldName == null) { return state; }

				if (previewObj != null) {
					if (currentObj.SectionName != null) {
						if (previewObj.SectionName != null) {
							if (!action.value.TargetIsRoot) {
								if (previewObj.SectionName !== currentObj.SectionName && !action.value.TargetIsRoot) { // move element from a section to another section
									moveElementFromASectionToAnotherSection(action.value);
									return state;
								} else {// order element in the same section
									if (previewObj.FieldName == null)// move element in first position
									{
										moveElementInTheSameSectionInTheFirstPlace(action.value);
										return state;

									} else { // move after another element
										moveElementInTheSameSectionAfterAnotherElement(action.value);
										return state;
									}
								}
							}
							else { // move element outside the section after a section
								moveElementOusideFromSectionAfterAnotherSection(action.value);
							}
						}
						else {

							if (previewObj.FieldName != null) { // move element outsite a section after another element
								moveElementOutsideFromSectionAfterAnotherElement(action.value);
								return state;
							} else { // move element outside from a section in the first place
								moveElementOutsideFromSectionInTheFirstPosition(action.value);
								return state;
							}
						}
					} else { // currentObj.SectionName == null
						if (previewObj.SectionName != null) {
							if (!action.value.TargetIsRoot) {// move outside element inside a section
								moveOutsideElementInsideASection(action.value);
								return state;
							}
							else {
								// move outside element after a section
								moveOusideElementAfterASection(action.value);
								return state;
							}


						} else { // previewObj.SectionName == null

							if (previewObj.FieldName != null) // move outsite element after another element
							{
								moveOutsideElementAfterAnotherElement(action.value);
								return state;
							}
							else { // move outside element in the first place
								moveOutsideElementInTheFirstPlace(action.value);
								return state;
							}
						}
					}
				} else {// previewElement == null
					if (currentObj.SectionName == null) {// move outside element in the first place
						moveOutsideElementInTheFirstPlace(action.value);
						return state;
					} else { // move element outside from a section in the first place
						moveElementOutsideFromSectionInTheFirstPosition(action.value);
						return state;
					}
				}
			}
			return state;
		}

		case 'UPDATE': {
			const propName = action.value.Schema.name;
			const required = action.value.Schema.fieldRequired;

			const normalizedField = state.FormTemplateNormalizationFields.find(f => f.fieldId === propName);
			const normalizedFieldIndex = state.FormTemplateNormalizationFields.findIndex(f => f.fieldId === propName);

			const normalizedFieldId = action.value.Schema.normalizationFieldId;
			const formTemplateNormalizationFieldStatusId = action.value.Schema.formTemplateNormalizationFieldStatusId;
			const normalizedFieldExceptionCriteriaId = action.value.Schema.normalizationExceptionId;
			const normalizedFieldExceptionCriteriaValue = action.value.Schema.normalizationExceptionValue;
			const exceptionAlias = action.value.Schema.exceptionAlias;
			const exceptionTypeId = action.value.Schema.exceptionTypeId;
			const normalizationClassId = action.value.Schema.normalizationClassId;
			const normalizationClassName = action.value.Schema.normalizationClassName;
			const normalizationSubClassId = action.value.Schema.normalizationSubClassId;
			const normalizationSubClassName = action.value.Schema.normalizationSubClassName;
			const normalizationFieldName = action.value.Schema.normalizationFieldName;

			const normalizationFieldDataType = action.value.Schema.normalizationFieldDataType;
			const fieldName = action.value.Schema.title;

			if (action.value.Type !== StoreObjectType.Section) {
				if (normalizedFieldIndex >= 0 && normalizedField == null) {
					state.FormTemplateNormalizationFields.splice(normalizedFieldIndex, 1);
					state.FormTemplateNormalizationFields.push({
						fieldId: propName,
						fieldNormalizationId: null,
						formTemplateNormalizationFieldStatusId,
						dataType: normalizationFieldDataType,
						fieldName,
						exceptionAlias,
						classId: normalizationClassId,
						className: normalizationClassName,
						subClassId: normalizationSubClassId,
						subClassName: normalizationSubClassName,
						normalizationFieldName
					} as FormTemplateNormalizationField);
				}
				else {
					if (normalizedFieldIndex >= 0) {
						state.FormTemplateNormalizationFields[normalizedFieldIndex].fieldNormalizationId = normalizedFieldId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].formTemplateNormalizationFieldStatusId = formTemplateNormalizationFieldStatusId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].normalizationFieldExceptionCriteriaId = normalizedFieldExceptionCriteriaId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].normalizationFieldExceptionCriteriaValue = normalizedFieldExceptionCriteriaValue;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].exceptionAlias = exceptionAlias;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].exceptionTypeId = exceptionTypeId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].dataType = normalizationFieldDataType;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].fieldName = fieldName;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].classId = normalizationClassId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].className = normalizationClassName;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].subClassId = normalizationSubClassId;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].subClassName = normalizationSubClassName;
						state.FormTemplateNormalizationFields[normalizedFieldIndex].normalizationFieldName = normalizationFieldName;
					} else {
						state.FormTemplateNormalizationFields.push({
							fieldId: propName,
							fieldNormalizationId: normalizedFieldId,
							formTemplateNormalizationFieldStatusId,
							normalizationFieldExceptionCriteriaId: normalizedFieldExceptionCriteriaId,
							normalizationFieldExceptionCriteriaValue: normalizedFieldExceptionCriteriaValue,
							exceptionAlias,
							exceptionTypeId,
							dataType: normalizationFieldDataType,
							fieldName,
							classId: normalizationClassId,
							className: normalizationClassName,
							subClassId: normalizationSubClassId,
							subClassName: normalizationSubClassName,
							normalizationFieldName
						} as FormTemplateNormalizationField);
					}
				}
			}

			if (action.value.Type === StoreObjectType.AnyOf) {
				// tslint:disable-next-line:no-shadowed-variable
				const propName = action.value.Schema.name;
				state.Schema.properties[propName].title = action.value.Schema.title;
				state.Schema.properties[propName].description = action.value.Schema.description;
				// state.Schema.properties[propName]['formTemplateNormalizationFieldStatusId'] = formTemplateNormalizationFieldStatusId;
				// state.Schema.properties[propName]['normalizationFieldId'] = normalizedFieldId;
				// state.Schema.properties[propName]['normalizationExceptionId'] = normalizedFieldExceptionCriteriaId;
				// state.Schema.properties[propName]['normalizationExceptionValue'] = normalizedFieldExceptionCriteriaValue;
				// state.Schema.properties[propName]['exceptionAlias'] = exceptionAlias;
				// state.Schema.properties[propName]['exceptionTypeId'] = exceptionTypeId;
				// state.Schema.properties[propName]['normalizationClassId'] = normalizationClassId;
				// state.Schema.properties[propName]['normalizationClassName'] = normalizationClassName;
				// state.Schema.properties[propName]['normalizationSubClassId'] = normalizationSubClassId;
				// state.Schema.properties[propName]['normalizationSubClassName'] = normalizationSubClassName;
				// state.Schema.properties[propName]['normalizationFieldName'] = normalizationFieldName;

				if (action.value.Schema.anyOf) {
					delete state.Schema.properties[propName].anyOf;
					state.Schema.properties[propName].anyOf = action.value.Schema.anyOf;
					addHiddenElementForAnyOfSection(action.value, propName);
				}

				return state;
			}
			else if (action.value.Type === StoreObjectType.Section) {
				// tslint:disable-next-line:no-shadowed-variable
				const propName = action.value.Schema.name;
				state.Schema.properties[propName].title = action.value.Schema.title;
				state.Schema.properties[propName].description = action.value.Schema.description;
				return state;
			}
			if (action.value.Type === StoreObjectType.Field || action.value.Type === StoreObjectType.AnyOfField) {
				delete action.value.Schema.name;
				delete action.value.Schema.fieldRequired;

				if (action.value.CurrentStoreObj.AnyOfOptionName && action.value.Type === StoreObjectType.AnyOfField) {
					updateElementFromAnyOf(action.value, propName, required);
				}
				else if (isNullOrWhiteSpace(action.value.CurrentStoreObj.SectionName)) {
					updateElement(action.value, propName, required);
				}
				else {
					updateElementFromSection(action.value, propName, required);
				}
			}
			return state;
		}

		case 'REMOVE': {
			const elementName = action.value.CurrentStoreObj.FieldName;
			const sectionName = action.value.CurrentStoreObj.SectionName;
			const anyOfActionName = action.value.CurrentStoreObj.AnyOfOptionName;

			removeNormalizationField(elementName);
			removeNormalizationField(sectionName);

			if (sectionName && elementName && anyOfActionName) {
				removeElementFromAnyOfSection(sectionName, elementName, anyOfActionName);
				return state;
			}

			if (elementName == null) {
				if (sectionName != null) {
					removeSection(sectionName);
				}
			}
			else {
				if (sectionName == null) {
					removeElement(elementName);
				}
				else {
					removeElementFromSection(sectionName, elementName);
				}
			}
			return state;
		}

		default:
			return state;
	}

	function removeNormalizationField(propName: string) {
		const normalizedFieldIndex = state.FormTemplateNormalizationFields.findIndex(f => f.fieldId === propName);
		if (normalizedFieldIndex >= 0) { state.FormTemplateNormalizationFields.splice(normalizedFieldIndex, 1); }
	}

	function moveSectionAfterAnotherSection(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.SectionName);
		let newIndex = getOrderElementPosition(storeObject.PreviewStoreObj.SectionName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.SectionName);
	}

	function moveSectionAfterAnotherElement(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.SectionName);
		let newIndex = getOrderElementPosition(storeObject.PreviewStoreObj.FieldName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.SectionName);
	}

	function moveSectionInTheFirstPlace(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.SectionName);
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].unshift(storeObject.CurrentStoreObj.SectionName);
	}

	function moveElementFromASectionToAnotherSection(storeObject: StoreObject): void {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.SectionName][storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addElementToSection({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.CurrentStoreObj.AnyOfOptionName
			},
			TargetIsRoot: false,
			PreviewStoreObj: storeObject.PreviewStoreObj,
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElementFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
	}

	function moveElementInTheSameSectionAfterAnotherElement(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPositionFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
		let newIndex = getOrderElementPositionFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.PreviewStoreObj.FieldName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(currentIndex, 1);
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.FieldName);
	}

	function moveElementInTheSameSectionInTheFirstPlace(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPositionFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(currentIndex, 1);
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].unshift(storeObject.CurrentStoreObj.FieldName);
	}

	function moveOutsideElementInsideASection(storeObject: StoreObject): void {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addElementToSection({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.PreviewStoreObj.FieldName
			},
			TargetIsRoot: false,
			PreviewStoreObj: storeObject.PreviewStoreObj,
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElement(storeObject.CurrentStoreObj.FieldName);
	}

	function moveOusideElementAfterASection(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.FieldName);
		let newIndex = getOrderElementPosition(storeObject.PreviewStoreObj.SectionName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.FieldName);
	}

	function moveOutsideElementAfterAnotherElement(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.FieldName);
		let newIndex = getOrderElementPosition(storeObject.PreviewStoreObj.FieldName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.FieldName);
	}

	function moveOutsideElementInTheFirstPlace(storeObject: StoreObject): void {
		const currentIndex = getOrderElementPosition(storeObject.CurrentStoreObj.FieldName);
		state.UiSchema['ui:order'].splice(currentIndex, 1);
		state.UiSchema['ui:order'].unshift(storeObject.CurrentStoreObj.FieldName);
	}

	function moveElementOutsideFromSectionInTheFirstPosition(storeObject: StoreObject): void {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.SectionName][storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addElement({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: null,
				AnyOfOptionName: null
			},
			TargetIsRoot: true,
			PreviewStoreObj: storeObject.PreviewStoreObj,
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElementFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
	}

	function moveElementOutsideFromSectionAfterAnotherElement(storeObject: StoreObject): void {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.SectionName][storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addElement({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: null,
				AnyOfOptionName: null
			},
			TargetIsRoot: true,
			PreviewStoreObj: storeObject.PreviewStoreObj,
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElementFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
	}

	function moveElementOusideFromSectionAfterAnotherSection(storeObject: StoreObject): void {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.SectionName][storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;
		addElement({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: null,
				AnyOfOptionName: null
			},
			TargetIsRoot: true,
			PreviewStoreObj: {
				FieldName: storeObject.PreviewStoreObj.SectionName,
				SectionName: null,
				AnyOfOptionName: null
			},
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElementFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
	}

	function moveFieldOutsideAnyOfToAnyOfOption(storeObject: StoreObject) {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addAnyOfElement({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.PreviewStoreObj.AnyOfOptionName
			},
			TargetIsRoot: true,
			PreviewStoreObj: {
				FieldName: storeObject.PreviewStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.PreviewStoreObj.AnyOfOptionName
			},
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElement(storeObject.CurrentStoreObj.FieldName);
	}

	function moveFieldInsideAnyOfToAnyOfOption(storeObject: StoreObject) {
		const currentIndex = state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].indexOf(storeObject.CurrentStoreObj.FieldName);
		let newIndex = state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].indexOf(storeObject.PreviewStoreObj.FieldName);
		if (currentIndex > newIndex) { newIndex = newIndex + 1; }
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(currentIndex, 1);
		state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(newIndex, 0, storeObject.CurrentStoreObj.FieldName);
	}

	function moveFieldInsideASectionToAnyOfOption(storeObject: StoreObject) {
		const currentSchema = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[storeObject.CurrentStoreObj.FieldName];
		const currentSchemaUi = state.UiSchema[storeObject.CurrentStoreObj.SectionName][storeObject.CurrentStoreObj.FieldName];
		const required = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.indexOf(storeObject.CurrentStoreObj.FieldName) >= 0;

		addAnyOfElement({
			Schema: currentSchema,
			UiSchema: currentSchemaUi,
			FormData: null,
			FormDataHasErrors: false,
			CurrentStoreObj: {
				FieldName: storeObject.CurrentStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.PreviewStoreObj.AnyOfOptionName
			},
			TargetIsRoot: true,
			PreviewStoreObj: {
				FieldName: storeObject.PreviewStoreObj.FieldName,
				SectionName: storeObject.PreviewStoreObj.SectionName,
				AnyOfOptionName: storeObject.PreviewStoreObj.AnyOfOptionName
			},
			Type: action.value.Type
		}, storeObject.CurrentStoreObj.FieldName, required);

		removeElementFromSection(storeObject.CurrentStoreObj.SectionName, storeObject.CurrentStoreObj.FieldName);
	}

	function addElementToSection(storeObject: StoreObject, propName: string, required: boolean): void {

		state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[propName] = simplifySchema(storeObject.Schema);
		if (required != null && required === true) { state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.push(propName); }
		state.UiSchema[storeObject.CurrentStoreObj.SectionName][propName] = storeObject.UiSchema;
		if (storeObject.PreviewStoreObj == null) {
			state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].push(propName);
		} else {
			if (storeObject.PreviewStoreObj.FieldName == null) {
				state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].unshift(propName);
			}
			else {
				state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].splice(state.UiSchema[storeObject.CurrentStoreObj.SectionName]['ui:order'].indexOf(storeObject.PreviewStoreObj.FieldName) + 1, 0, propName);
			}
		}
	}

	function addElement(storeObject: StoreObject, propName: string, required: boolean): void {
		state.Schema.properties[propName] = simplifySchema(storeObject.Schema);
		if (required != null && required === true) { state.Schema.required.push(propName); }
		state.UiSchema[propName] = storeObject.UiSchema;
		if (storeObject.PreviewStoreObj == null) {
			state.UiSchema['ui:order'].push(propName);
		}
		else {
			if (storeObject.PreviewStoreObj.FieldName == null) {
				if (storeObject.PreviewStoreObj.SectionName == null) {
					state.UiSchema['ui:order'].unshift(propName);
				} else {
					state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(storeObject.PreviewStoreObj.SectionName) + 1, 0, propName);
				}
			}
			else {
				state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(storeObject.PreviewStoreObj.FieldName) + 1, 0, propName);
			}
		}
	}

	function addAnyOfSection(storeObject: StoreObject, propName: string): void {
		state.Schema.properties[propName] = storeObject.Schema;
		state.UiSchema[propName] = storeObject.UiSchema;

		addHiddenElementForAnyOfSection(storeObject, propName);

		if (storeObject.PreviewStoreObj == null) {
			state.UiSchema['ui:order'].push(propName);
		}
		else {
			if (storeObject.PreviewStoreObj.SectionName == null) {
				if (storeObject.PreviewStoreObj.FieldName) {
					state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(storeObject.PreviewStoreObj.FieldName) + 1, 0, propName);
				} else { state.UiSchema['ui:order'].unshift(propName); }
			} else {
				state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(storeObject.PreviewStoreObj.SectionName) + 1, 0, propName);
			}
		}
	}

	function addHiddenElementForAnyOfSection(storeObject: StoreObject, propName: string): void {
		if (storeObject.Schema.anyOf.length > 0) {
			// tslint:disable-next-line:prefer-for-of
			for (let i = 0; i < storeObject.Schema.anyOf.length; i++) {
				const objectKeys: string[] = getObjectKeyToJson(storeObject.Schema.anyOf[i].properties);
				state.UiSchema[propName][objectKeys[0]] = { 'ui:widget': 'hidden' };
				if (state.UiSchema[propName]['ui:order'].indexOf(objectKeys[0]) < 0) {
					state.UiSchema[propName]['ui:order'].push(objectKeys[0]);
				}
			}
		}
	}

	function addAnyOfElement(storeObject: StoreObject, propName: string, required: boolean): void {
		const sectionName = storeObject.CurrentStoreObj.SectionName;
		const anyOfOptionName = storeObject.CurrentStoreObj.AnyOfOptionName;
		let found = false;

		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < state.Schema.properties[sectionName].anyOf.length; i++) {
			if (state.Schema.properties[sectionName].anyOf[i].title === anyOfOptionName) {
				found = true;
				if (!state.Schema.properties[sectionName].anyOf[i].properties) {
					state.Schema.properties[sectionName].anyOf[i].properties = {};
				}
				state.Schema.properties[sectionName].anyOf[i].properties[propName] = simplifySchema(storeObject.Schema);
				if (required) { state.Schema.properties[sectionName].anyOf[i].required.push(propName); }
			}
		}

		if (!found) {
			state.Schema.properties[sectionName].properties[propName] = simplifySchema(storeObject.Schema);
		}

		state.UiSchema[sectionName][propName] = storeObject.UiSchema;
		if (storeObject.PreviewStoreObj == null) {
			state.UiSchema[sectionName]['ui:order'].push(propName);
		}
		else {
			if (storeObject.PreviewStoreObj.FieldName == null) {
				state.UiSchema[sectionName]['ui:order'].unshift(propName);
			} else {
				state.UiSchema[sectionName]['ui:order'].splice(state.UiSchema[sectionName]['ui:order'].indexOf(storeObject.PreviewStoreObj.FieldName) + 1, 0, propName);
			}
		}
	}

	function updateElement(storeObject: StoreObject, propName: string, required: boolean) {
		state.Schema.properties[propName] = simplifySchema(storeObject.Schema);
		state.UiSchema[propName] = storeObject.UiSchema;
		const requiredPos = state.Schema.required.indexOf(propName);

		if (required === true && requiredPos < 0) {
			state.Schema.required.push(propName);
		}
		if (required === false && requiredPos >= 0) {
			state.Schema.required.splice(requiredPos, 1);
		}
	}

	function simplifySchema(storeObjectSchema: { [key: string]: any }) {
		const schema = { ...storeObjectSchema };

		delete schema.normalizationClassId;
		delete schema.normalizationClassName;
		delete schema.normalizationSubClassId;
		delete schema.normalizationSubClassName;
		delete schema.normalizationFieldName;
		delete schema.formTemplateNormalizationFieldStatusId;
		delete schema.normalizationFieldId;
		delete schema.normalizationFieldDataType;
		delete schema.normalizationExceptionId;
		delete schema.normalizationExceptionValue;
		delete schema.exceptionAlias;
		delete schema.exceptionTypeId;

		return schema;
	}

	function updateElementFromSection(storeObject: StoreObject, propName: string, required: boolean) {
		state.Schema.properties[storeObject.CurrentStoreObj.SectionName].properties[propName] = simplifySchema(storeObject.Schema);
		state.UiSchema[storeObject.CurrentStoreObj.SectionName][propName] = storeObject.UiSchema;
		const requiredPos = getRequiredElementPositionFromSection(storeObject.CurrentStoreObj.SectionName, propName);

		if (required === true && requiredPos < 0) {
			state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.push(propName);
		}
		if (required === false && requiredPos >= 0) {
			state.Schema.properties[storeObject.CurrentStoreObj.SectionName].required.splice(requiredPos, 1);
		}
	}

	function updateElementFromAnyOf(storeObject: StoreObject, propName: string, required: boolean) {

		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf.length; i++) {
			if (state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf[i].title === storeObject.CurrentStoreObj.AnyOfOptionName) {
				state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf[i].properties[propName] = simplifySchema(storeObject.Schema);
				const requiredPos = state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf[i].required.indexOf(propName);
				if (required === true && requiredPos < 0) {
					state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf[i].required.push(propName);
				}
				if (required === false && requiredPos >= 0) {
					state.Schema.properties[storeObject.CurrentStoreObj.SectionName].anyOf[i].required.splice(requiredPos, 1);
				}
			}
		}

		state.UiSchema[storeObject.CurrentStoreObj.SectionName][propName] = storeObject.UiSchema;
	}


	function removeElementFromSection(sectionName: string, fieldName: string): void {

		delete state.Schema.properties[sectionName].properties[fieldName];
		delete state.UiSchema[sectionName][fieldName];

		const requiredPos = getRequiredElementPositionFromSection(sectionName, fieldName);
		if (requiredPos >= 0) { state.Schema.properties[sectionName].required.splice(requiredPos, 1); }

		const orderPos = getOrderElementPositionFromSection(sectionName, fieldName);
		state.UiSchema[sectionName]['ui:order'].splice(orderPos, 1);
	}

	function removeElement(elementName: string): void {
		delete state.Schema.properties[elementName];
		delete state.UiSchema[elementName];
		const requiredPos = state.Schema.required.indexOf(elementName);
		if (requiredPos >= 0) { state.Schema.required.splice(requiredPos, 1); }
		state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(elementName), 1);
	}

	function removeElementFromAnyOfSection(sectionName: string, fieldName: string, optionName: string): void {
		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < state.Schema.properties[sectionName].anyOf.length; i++) {
			if (state.Schema.properties[sectionName].anyOf[i].title === optionName) {
				delete state.Schema.properties[sectionName].anyOf[i].properties[fieldName];
			}
			delete state.UiSchema[sectionName][fieldName];
			const requiredPos = state.Schema.properties[sectionName].anyOf[i].required.indexOf(fieldName);
			if (requiredPos >= 0) { state.Schema.properties[sectionName].anyOf[i].required.splice(requiredPos, 1); }
		}

		const orderPos = getOrderElementPositionFromSection(sectionName, fieldName);
		state.UiSchema[sectionName]['ui:order'].splice(orderPos, 1);
	}

	function removeSection(sectionName: string): void {
		let fields: string[] = getObjectKeyToJson(state.Schema.properties[sectionName].properties);
		fields.forEach(field => {
			removeNormalizationField(field);
		});

		if (state.Schema.properties[sectionName].anyOf) {
			// tslint:disable-next-line:prefer-for-of
			for (let i = 0; i < state.Schema.properties[sectionName].anyOf.length; i++) {
				fields = getObjectKeyToJson(state.Schema.properties[sectionName].anyOf[i].properties);
				if (fields && fields.length > 0) { fields = fields.filter(p => p.startsWith('FIELD')); }
				fields.forEach(field => {
					removeNormalizationField(field);
				});
			}
		}

		delete state.Schema.properties[sectionName];
		delete state.UiSchema[sectionName];
		state.UiSchema['ui:order'].splice(state.UiSchema['ui:order'].indexOf(sectionName), 1);
	}

	function addCloneElement(elementName: string) {
		const baseFormTemplateNormalizationField = state.FormTemplateNormalizationFields.find(f => f.fieldId === elementName);

		const clonedElementName = getCloneElementName(elementName);
		const required = state.Schema.required.indexOf(elementName) >= 0;

		state.Schema.properties[clonedElementName] = JSON.parse(JSON.stringify(state.Schema.properties[elementName]));
		state.UiSchema[clonedElementName] = JSON.parse(JSON.stringify(state.UiSchema[elementName]));
		state.Schema.properties[clonedElementName].formTemplateNormalizationFieldStatusId =
			getNormalizationFieldsStatus(elementName);

		if (required) { state.Schema.required.push(clonedElementName); }

		const currentIndex = state.UiSchema['ui:order'].indexOf(elementName);
		state.UiSchema['ui:order'].splice(currentIndex + 1, 0, clonedElementName);

		addNormalizationFields(null, clonedElementName, null, baseFormTemplateNormalizationField);
	}

	function addCloneHiddenElementToAnyOfSection(sectionName: string, elementName: string, anyOfActionName: string) {
		const numbersOfSelection = elementName.match(/\d+$/g);
		const numberOfSelection = numbersOfSelection != null && numbersOfSelection.length > 0 ? numbersOfSelection[0] : 0;
		const clonedElementName = `${sectionName}Selection${numberOfSelection}`;

		// tslint:disable-next-line:prefer-for-of
		for (let index = 0; index < state.Schema.properties[sectionName].anyOf.length; index++) {
			if (state.Schema.properties[sectionName].anyOf[index].title === anyOfActionName) {
				state.Schema.properties[sectionName].anyOf[index].properties[clonedElementName] =
					state.Schema.properties[sectionName].anyOf[index].properties[elementName];
			}
		}
		state.UiSchema[sectionName][clonedElementName] = JSON.parse(JSON.stringify(state.UiSchema[sectionName][elementName]));

		const currentIndex = state.UiSchema[sectionName]['ui:order'].indexOf(elementName);
		state.UiSchema[sectionName]['ui:order'].splice(currentIndex + 1, 0, clonedElementName);
	}

	function addCloneElementToAnyOfSection(sectionName: string, elementName: string, anyOfActionName: string) {
		const baseFormTemplateNormalizationField = state.FormTemplateNormalizationFields.find(f => f.fieldId === elementName);
		const clonedElementName = getCloneElementName(elementName);
		const required = state.Schema.properties[sectionName].required.indexOf(elementName) >= 0;

		// tslint:disable-next-line:prefer-for-of
		for (let index = 0; index < state.Schema.properties[sectionName].anyOf.length; index++) {
			if (state.Schema.properties[sectionName].anyOf[index].title === anyOfActionName) {
				state.Schema.properties[sectionName].anyOf[index].properties[clonedElementName] =
					state.Schema.properties[sectionName].anyOf[index].properties[elementName];
				state.Schema.properties[sectionName].anyOf[index].properties[clonedElementName].formTemplateNormalizationFieldStatusId =
					getNormalizationFieldsStatus(elementName);
			}
		}
		state.UiSchema[sectionName][clonedElementName] = JSON.parse(JSON.stringify(state.UiSchema[sectionName][elementName]));

		if (required) { state.Schema.properties[sectionName].required.push(clonedElementName); }

		const currentIndex = state.UiSchema[sectionName]['ui:order'].indexOf(elementName);
		state.UiSchema[sectionName]['ui:order'].splice(currentIndex + 1, 0, clonedElementName);

		addNormalizationFields(sectionName, clonedElementName, anyOfActionName, baseFormTemplateNormalizationField);
	}

	function addCloneElementToSection(sectionName: string, elementName: string) {
		const baseFormTemplateNormalizationField = state.FormTemplateNormalizationFields.find(f => f.fieldId === elementName);

		const clonedElementName = getCloneElementName(elementName);
		const required = state.Schema.properties[sectionName].required.indexOf(elementName) >= 0;

		state.Schema.properties[sectionName].properties[clonedElementName] = JSON.parse(JSON.stringify(state.Schema.properties[sectionName].properties[elementName]));
		state.UiSchema[sectionName][clonedElementName] = JSON.parse(JSON.stringify(state.UiSchema[sectionName][elementName]));
		state.Schema.properties[sectionName].properties[clonedElementName].formTemplateNormalizationFieldStatusId =
			getNormalizationFieldsStatus(elementName);

		if (required) { state.Schema.properties[sectionName].required.push(clonedElementName); }

		const currentIndex = state.UiSchema[sectionName]['ui:order'].indexOf(elementName);
		state.UiSchema[sectionName]['ui:order'].splice(currentIndex + 1, 0, clonedElementName);

		addNormalizationFields(sectionName, clonedElementName, null, baseFormTemplateNormalizationField);
	}

	function addCloneSection(sectionName: string) {
		const clonedSectionName = getCloneSectionName(sectionName);
		state.Schema.properties[clonedSectionName] = JSON.parse(JSON.stringify(state.Schema.properties[sectionName]));
		state.UiSchema[clonedSectionName] = JSON.parse(JSON.stringify(state.UiSchema[sectionName]));

		const currentIndex = state.UiSchema['ui:order'].indexOf(sectionName);
		state.UiSchema['ui:order'].splice(currentIndex + 1, 0, clonedSectionName);

		if (state.Schema.properties[sectionName].anyOf != null) {
			const baseFormTemplateNormalizationField = state.FormTemplateNormalizationFields.find(f => f.fieldId === sectionName);
			addNormalizationFields(clonedSectionName, null, null, baseFormTemplateNormalizationField);
		}

		let fields: string[] = getObjectKeyToJson(state.Schema.properties[clonedSectionName].properties);
		if (fields && fields.length > 0) { cloneElementsToSection(clonedSectionName, fields); }

		fields = [];
		if (state.Schema.properties[clonedSectionName].anyOf) {
			// tslint:disable-next-line:prefer-for-of
			for (let i = 0; i < state.Schema.properties[clonedSectionName].anyOf.length; i++) {
				fields.push(...getObjectKeyToJson(state.Schema.properties[clonedSectionName].anyOf[i].properties));
				cloneElementsForAnyOfSection(clonedSectionName, state.Schema.properties[clonedSectionName].anyOf[i].title, fields);
				fields = [];
			}
		}
	}

	function cloneElementsForAnyOfSection(sectionName: string, optionName: string, fields: string[]) {
		if (!fields || fields.length === 0) { return; }
		const fieldElements = fields.filter(p => p.startsWith('FIELD'));
		fieldElements.forEach(field => {
			addCloneElementToAnyOfSection(sectionName, field, optionName);
			removeElementFromAnyOfSection(sectionName, field, optionName);
		});

		const hiddenElements = fields.filter(p => p.startsWith('SEC'));
		hiddenElements.forEach(field => {
			addCloneHiddenElementToAnyOfSection(sectionName, field, optionName);
			removeElementFromAnyOfSection(sectionName, field, optionName);
		});
	}

	function cloneElementsToSection(sectionName: string, fields: string[]) {
		fields.forEach(field => {
			addCloneElementToSection(sectionName, field);
			removeElementFromSection(sectionName, field);
		});
	}

	function addNormalizationFields(sectionName: string, elementName: string, anyOfActionName: string = null, baseFormTemplateNormalizationField: FormTemplateNormalizationField = null) {
		let schemaForField: ReactSchema;
		const optionId = getAnyOfOptionId(sectionName, anyOfActionName);

		if (sectionName) {
			if (anyOfActionName) {
				if (state.Schema.properties[sectionName].anyOf && state.Schema.properties[sectionName].anyOf[optionId]) {
					schemaForField = state.Schema.properties[sectionName].anyOf[optionId].properties[elementName];
				}
			}
			else if (elementName) {
				schemaForField = state.Schema.properties[sectionName].properties[elementName];
			}
			else if (state.Schema.properties[sectionName].anyOf == null) { return; }
			else { schemaForField = state.Schema.properties[sectionName]; }
		}
		else { schemaForField = state.Schema.properties[elementName]; }

		// let normalizedField = schemaForField['normalizationFieldId'];
		// let formTemplateNormalizationFieldStatusId = normalizedField == null ? NormalizationFieldStatus.Default : schemaForField['formTemplateNormalizationFieldStatusId'];
		// let normalizedFieldExceptionCriteriaId = schemaForField["normalizationExceptionId"];
		// let normalizedFieldExceptionCriteriaValue = schemaForField["normalizationExceptionValue"];
		// let exceptionAlias = `${schemaForField["exceptionAlias"]}_${elementName ? elementName : sectionName}`;
		// let exceptionTypeId = schemaForField["exceptionTypeId"];
		// let dataType = schemaForField["format"] || schemaForField["type"];
		// let fieldName = schemaForField["title"];


		const fieldId = elementName ? elementName : sectionName;
		const normalizationFieldId = baseFormTemplateNormalizationField.fieldNormalizationId;
		const formTemplateNormalizationFieldStatusId = baseFormTemplateNormalizationField.formTemplateNormalizationFieldStatusId || NormalizationFieldStatus.Default;
		const normalizedFieldExceptionCriteriaId = baseFormTemplateNormalizationField.normalizationFieldExceptionCriteriaId;
		const normalizedFieldExceptionCriteriaValue = baseFormTemplateNormalizationField.normalizationFieldExceptionCriteriaValue;
		const exceptionAlias = `${baseFormTemplateNormalizationField.exceptionAlias}_${elementName ? elementName : sectionName}`;
		const exceptionTypeId = baseFormTemplateNormalizationField.exceptionTypeId;
		const dataType = baseFormTemplateNormalizationField.dataType;
		const fieldName = schemaForField.title;

		state.FormTemplateNormalizationFields.push({
			fieldId,
			fieldNormalizationId: normalizationFieldId,
			formTemplateNormalizationFieldStatusId,
			normalizationFieldExceptionCriteriaId: normalizedFieldExceptionCriteriaId,
			normalizationFieldExceptionCriteriaValue: normalizedFieldExceptionCriteriaValue,
			exceptionAlias,
			exceptionTypeId,
			dataType,
			fieldName,
			classId: baseFormTemplateNormalizationField.classId,
			className: baseFormTemplateNormalizationField.className,
			subClassId: baseFormTemplateNormalizationField.subClassId,
			subClassName: baseFormTemplateNormalizationField.subClassName,
			normalizationFieldName: baseFormTemplateNormalizationField.normalizationFieldName
		} as FormTemplateNormalizationField);

		// if (sectionName)
		//   if (anyOfActionName) state.Schema.properties[sectionName].anyOf[optionId].properties[elementName].exceptionAlias = exceptionAlias;
		//   else if (elementName)
		//     state.Schema.properties[sectionName].properties[elementName].exceptionAlias = exceptionAlias;
		//   else state.Schema.properties[sectionName].exceptionAlias = exceptionAlias;
		// else state.Schema.properties[elementName].exceptionAlias = exceptionAlias;
	}

	function getRequiredElementPositionFromSection(sectionName: string, elementName: string): number {
		return state.Schema.properties[sectionName].required.indexOf(elementName);
	}

	function getOrderElementPosition(elementName: string): number {
		return state.UiSchema['ui:order'].indexOf(elementName);
	}

	function getOrderElementPositionFromSection(sectionName: string, elementName: string): number {
		return state.UiSchema[sectionName]['ui:order'].indexOf(elementName);
	}

	function getCloneElementName(elementName: string) {
		const fieldNumbers: number = getMaxFieldNumber();
		state.Schema.lastFieldNumber = (state.Schema.lastFieldNumber as number) + 1;
		return elementName ? `FIELD${fieldNumbers >= 9 ? fieldNumbers + 1 : `0${fieldNumbers + 1}`}` : null;

	}

	function getCloneSectionName(sectionName: string) {
		const sectionNumber: number = getMaxSectionNumber();
		state.Schema.lastSectionNumber = (state.Schema.lastSectionNumber as number) + 1;
		return sectionName ? `SEC${sectionNumber >= 9 ? sectionNumber + 1 : `0${sectionNumber + 1}`}` : null;
	}

	function getMaxFieldNumber(): number {
		return state.Schema.lastFieldNumber as number;
	}

	function getMaxSectionNumber(): number {
		return state.Schema.lastSectionNumber as number;
	}

	function getAnyOfOptionId(sectionName: string, optionName: string): number {
		if (!optionName) { return -1; }
		if (state.Schema.properties[sectionName].anyOf) {
			for (let i = 0; i < state.Schema.properties[sectionName].anyOf.length; i++) {
				if (state.Schema.properties[sectionName].anyOf[i].title === optionName) {
					return i;
				}
			}
		} else { return -1; }
	}

	function isNullOrWhiteSpace(str) {
		return str === null || str.match(/^ *$/) !== null;
	}

	function updateFormDataAfterChange(schema: any, formData: any) {
		if (schema && (Object.keys(schema).length === 0)) { return formData; }
		const fields: string[] = getObjectKeyToJson(schema.properties);
		let sections: string[] = [];
		if (fields && fields.length > 0) { sections = fields.filter(p => p.startsWith('SEC')); }
		if (sections && sections.length > 0) {
			sections.forEach(section => {
				if (schema.properties[section]) {
					fields.push(...getObjectKeyToJson(schema.properties[section].properties));
				}
				if (schema.properties[section].anyOf && schema.properties[section].anyOf.length > 0) {
					// tslint:disable-next-line:prefer-for-of
					for (let i = 0; i < schema.properties[section].anyOf.length; i++) {
						fields.push(...getObjectKeyToJson(schema.properties[section].anyOf[i].properties));
					}
				}
			});
		}
		const fieldsFromFormData: string[] = getObjectKeyToJson(formData);
		if (fieldsFromFormData && fieldsFromFormData.length > 0) {
			const sectionsFormData: string[] = fieldsFromFormData.filter(p => p.startsWith('SEC'));
			if (sectionsFormData && sectionsFormData.length > 0) {
				sectionsFormData.forEach(sectionFormData => {
					fieldsFromFormData.push(...getObjectKeyToJson(formData[sectionFormData]));
				});
			}
			fieldsFromFormData.forEach(data => {
				if (!fields.find(p => p === data)) {
					if (formData[data]) { delete formData[data]; }
					else {
						sections.forEach(section => {
							if (formData[section] && formData[section][data]) {
								delete formData[section][data];
							}
						});
					}
				}
			});
		}
		return formData;
	}

	function getNormalizationFieldsStatus(fieldId: string): number {
		const normalizationField = state.FormTemplateNormalizationFields.find(p => p.fieldId === fieldId);
		if (!normalizationField) { return NormalizationFieldStatus.Default; }
		return normalizationField.formTemplateNormalizationFieldStatusId;
	}

	function getObjectKeyToJson(object: any) {
		if (!object) { return ''; }
		return JSON.parse(JSON.stringify(Object.keys(object)));
	}
}
